// GitLab/Unleash is legacy: create every NEW flag in GrowthBook and add it here as
// 'growthbook'. An unlisted flag falls back to 'gitlab' and always reads false.
// Keep in sync with PROVIDERS_BY_FLAG in app/lib/feature_flags.rb.
const PROVIDERS_BY_FLAG = {
  ff_funnel_bypass: 'growthbook',
  ff_imp_8240_timezone_management: 'gitlab',
  ff_modal_photos_gifted_reviews: 'gitlab',
  ff_photos_gifted_reviews: 'gitlab',
  imp_6858_creators_statistics: 'growthbook',
  imp_10630_tiktok_shop_targeting: 'gitlab',
  imp_11831_brief_with_ai: 'gitlab',
  imp_11862_ai_matching_agent: 'gitlab',
  imp_13016_allow_shopify_bundles: 'growthbook',
  imp_13218_campaign_preview_rn: 'growthbook',
  imp_13448_human_bureau_for_brands: 'growthbook',
}

export const getFeatureFlagProvider = flagName =>
  PROVIDERS_BY_FLAG[flagName] || 'gitlab'

export default PROVIDERS_BY_FLAG
